import React from 'react';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from '../../../../../../../../../../CommonComponents/OPL/Popover/Popover';
import { IconButton } from '../../../../../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { Text } from '../../../../../../../../../../CommonComponents/OPL/Text/Text';

export const GstExemptPopover = () => {
  return (
    <Popover>
      <PopoverTrigger>
        <IconButton
          icon="far fa-question-circle"
          size="small"
          variant="subtleInactive"
          aria-label="Help"
        />
      </PopoverTrigger>

      <PopoverContent
        side="top"
        width={248}
        p="16"
        onKeyDown={evt => {
          if (evt.key === 'Escape') {
            // Prevent closing the modal when pressing escape to close the popover
            evt.stopPropagation();
          }
        }}
      >
        <Text color="neutral.500">
          The GST exemption allows the earmarking of transfers, made during lifetime or at death,
          that either skip a generation or are made in trust for multiple generations.
        </Text>
      </PopoverContent>

      <PopoverClose />
    </Popover>
  );
};
